import { config } from './config';

const { cognito } = config;

/** Cognito requires an exact redirect match; include env URL plus current origin (Amplify per-branch URLs). */
function buildOAuthRedirectUrls(): string[] {
  const urls = new Set<string>();

  const addUrl = (raw: string) => {
    const url = raw.trim();
    if (!url) return;
    urls.add(url);
    if (url.endsWith('/')) {
      const withoutSlash = url.replace(/\/+$/, '');
      if (withoutSlash) urls.add(withoutSlash);
    } else {
      urls.add(`${url}/`);
    }
  };

  addUrl(cognito.oauthRedirectUrl);

  const extras = process.env.REACT_APP_OAUTH_REDIRECT_URLS;
  if (typeof extras === 'string') {
    for (const part of extras.split(',')) addUrl(part);
  }

  if (typeof window !== 'undefined') {
    addUrl(window.location.origin);
  }

  return Array.from(urls);
}

const oauthRedirectUrls = buildOAuthRedirectUrls();

const awsConfig: any = {
  Auth: {
    Cognito: {
      userPoolId: cognito.userPoolId,
      userPoolClientId: cognito.appClientId,
      loginWith: {
        oauth: {
          domain: cognito.domain,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: oauthRedirectUrls,
          redirectSignOut: oauthRedirectUrls,
          responseType: 'code'
        }
      }
    }
  }
};

export default awsConfig;
